<template>
  <v-card style="border-radius:5px" v-if="showJob" class="ma-2" @click="$emit('job')">
    <v-list-item>
      <v-list-item-avatar tile size="80">
        <v-img :src="require(`@/assets/${job.category}.svg`)">
        </v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title">
          {{job.title|trimLength}}
        </v-list-item-title>

        <v-list-item-subtitle class="subtitle">
              <span>${{job.compensation}}<span v-if="job.rateType ==='Hourly'">/</span><span v-if="job.rateType ==='Hourly'" class="caption">hr</span> </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- <v-layout row wrap>
      <v-flex xs3 px-2 d-flex>
        <v-layout column justify-center>
          <v-img :src="require(`@/assets/${job.category}.svg`)" contain class="" height="40">
          </v-img>
        </v-layout>
      </v-flex>
      <v-flex xs9>
        <v-layout column py-3>
          <v-flex>
            <v-layout row align-end justify-space-between>
              <span class="text-xs-left title">{{job.title|trimLength}}</span>
              <span class="text-xs-right font-weight-bold title pr-2">${{job.compensation}}<span v-if="job.rateType ==='Hourly'">/</span><span v-if="job.rateType ==='Hourly'" class="caption">hr</span> </span>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout row align-end justify-space-between>
              <span class="subtitle text-xs-right">{{ formatShortDate(this.job.dateUTC).month }} {{ formatShortDate(this.job.dateUTC).day }} <span class="caption">({{ formatDateTime(this.job.dateUTC) }})</span></span>
              <span class="text-xs-left pr-2">
                <span class="caption" v-if="job.repeat==='Does not repeat'">One Time Gig</span>
                <span class="caption" v-else>Daily Rate</span>
              </span>
            </v-layout>
          </v-flex>
          <v-flex>
            <v-layout row align-end justify-space-between>
              <span class="subtitle">{{job.startTime|formatTime}}</span>
              <span class="caption pr-2">{{job.dist}} mi. away</span>
            </v-layout>
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout> -->
  </v-card>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'

const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['jobKey'],
  data () {
    return {
      sub: '',
      showJob: false,
      job: {
        category: 'Agriculture'
      }
    }
  },
  mounted () {
    fb.database.ref(`/jobs/${this.jobKey}/public`).once('value').then(function (snapshot) {
      var job = snapshot.val()
      this.showJob = true
      this.job = job
    }.bind(this))
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),

    isHefe () {
      if (this.job.createdBy === this.currentUser.uid) {
        return true
      }
      return false
    }
  },
  methods: {
    openDialog () {
      this.$emit('job', this.job)
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    }
  },

  filters: {
    applicants (val) {
      return Object.keys(val).length
    },
    acceptedApplicants (val) {
      return Object.keys(val).reduce(function (acc, key) {
        if (val[key] === 'Applied') {
          return acc + 1
        }
        return acc
      }, 0)
    },
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    trimLength (val) {
      if (!val) {
        return '-'
      }
      if (val.length < 13) {
        return val
      }
      return `${val.substring(0, 13)}...`
    },
    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val, ['HH.mm']).format('hh:mm a')
    }
  }
}
</script>
